 document.addEventListener('DOMContentLoaded', function() {
  function getUpdatedCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const count = cart.item_count;
        
        const desktopCartCount = document.getElementById('cart-count');
        if (desktopCartCount) {
          desktopCartCount.textContent = `CART (${count})`;
        }

        const mobileCartCount = document.getElementById('mob-cart-count');
        if (mobileCartCount) {
          mobileCartCount.textContent = count;
        }

        console.log('REAL-TIME CART COUNT:', count);
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);
    const url = args[0];
    
    const isCartRequest = typeof url === 'string' && (
      url.includes('/cart/add') ||
      url.includes('/cart/update') ||
      url.includes('/cart/change') ||
      (url === '/cart.js' && args[1]?.method === 'POST')
    );

    if (isCartRequest) {
      setTimeout(getUpdatedCartCount, 300);
    }

    return response;
  };

  document.addEventListener('click', function(event) {
    if (event.target.closest('[data-remove-from-cart], [data-cart-remove], .cart__remove')) {
      setTimeout(getUpdatedCartCount, 300);
    }
  });

  document.addEventListener('change', function(event) {
    if (event.target.matches('input[data-quantity-input], input.cart__quantity')) {
      setTimeout(getUpdatedCartCount, 300);
    }
  });

  getUpdatedCartCount();
});